import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {TasksApi} from '../../../apis/TasksApi/TasksApi.ts';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery.tsx';

export function useGetTestKits(id?: string, enabled = true) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.testKits, id],
        queryFn: async () => {
            if (!id) return null;
            return await TasksApi.getTestKits(id);
        },
        enabled: !!id && enabled,
    });
}